const mentionedBlogSlider = document.querySelectorAll('[data-slider="mentioned-in-blog-slider"]');

const mentionedBlogSliderOptions = {
  slidesPerView: 1.2,

  spaceBetween: 20,
  speed: 800,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  breakpoints: {
    520: {
      slidesPerView: 2,
    },
    1023: {
      slidesPerView: 3,
    },
  },
};

mentionedBlogSlider.forEach((el) => {
  const parent = el.closest('.mentioned-in-blog');
  const paginationElement = parent.querySelector('.swiper-pagination');
  mentionedBlogSliderOptions.pagination.el = paginationElement;

  const arrowRight = parent.querySelector('.arrow-right');
  const arrowLeft = parent.querySelector('.arrow-left');

  mentionedBlogSliderOptions.navigation.nextEl = arrowRight;
  mentionedBlogSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, mentionedBlogSliderOptions);
});
